// src/utils/markdown.js

export function formatDate(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

// New function for loading raw HTML blog posts
export async function loadHtmlPost(file) {
  const res = await fetch(`/blog/posts/${file}`);
  const html = await res.text();
  return { html };
}
